import { Singleton } from "util";
import BaseService from "./base.service";
import axios from "axios";

@Singleton
class ErrorBoundariesService extends BaseService {
  async alert(message) {
    const url = `/proxy/front-end-error-alert`;
    await axios.post(
      process.env.REACT_APP_LOGENTRIES_HOOK,
      { message },
      { headers: { "Content-Type": "application/json" } }
    );
    return this.post(url, { message });
  }
}

export default ErrorBoundariesService;



// WEBPACK FOOTER //
// ./src/core/service/error-boundaries.service.js